import { Directive } from '@angular/core';

@Directive({
  selector: '[appFormAutoFillFix]'
})
export class FormAutoFillFixDirective {

  constructor() { }

}
